import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ReviewPage.css';

// Direct "write a review" deep links. iOS supports ?action=write-review to open the review composer.
// Play opens the listing where the user can rate. Google link is set once the Business Profile exists.
const CLIENT_IOS = 'https://apps.apple.com/app/id6759716088?action=write-review';
const CLIENT_ANDROID = 'https://play.google.com/store/apps/details?id=com.worldtechnologiessolutionsllc.besthand&hl=en_US';
const PRO_IOS = 'https://apps.apple.com/app/id6759719595?action=write-review';
const PRO_ANDROID = 'https://play.google.com/store/apps/details?id=com.worldtechnologiessolutionsllc.besthandpro&hl=en_US';
// TODO(prod): paste the Google Business Profile "write a review" short link (g.page/r/...).
const GOOGLE_REVIEW_URL = '';
// Trustpilot review link (free plan) — anyone can leave a review here for the claimed domain profile.
const TRUSTPILOT_URL = 'https://www.trustpilot.com/evaluate/besthandapp.com';

const Stars = () => (
  <div className={s.stars} aria-hidden="true">
    {[0, 1, 2, 3, 4].map((i) => (
      <svg key={i} viewBox="0 0 24 24" fill="#F5A623"><path d="m12 2 3.1 6.3 7 1-5 4.9 1.2 6.8L12 17.8 5.7 21l1.2-6.8-5-4.9 7-1L12 2Z" /></svg>
    ))}
  </div>
);

const ReviewPage = () => (
  <div className={s.page}>
    <header className={s.hero}>
      <div className={s.wrap}>
        <Stars />
        <h1 className={s.h1}>Love BestHand? Leave a review</h1>
        <p className={s.sub}>Your review helps neighbors find trusted help and helps great pros grow. It takes less than a minute — thank you!</p>
      </div>
    </header>

    <div className={s.wrap}>
      <div className={s.grid}>
        {/* Trustpilot FIRST — the public trust signal we push hardest (Paul 2026-07-25). */}
        {TRUSTPILOT_URL ? (
          <div className={`${s.card} ${s.cardFeatured}`}>
            <h2>⭐ Review us on Trustpilot</h2>
            <p>Share your experience publicly — it helps neighbors book with confidence.</p>
            <div className={s.btns}>
              <a className={`${s.btn} ${s.btnGoogle}`} href={TRUSTPILOT_URL} target="_blank" rel="noopener noreferrer">Write a Trustpilot review</a>
            </div>
          </div>
        ) : null}

        {GOOGLE_REVIEW_URL ? (
          <div className={s.card}>
            <h2>Review us on Google</h2>
            <p>Share your experience on our Google profile.</p>
            <div className={s.btns}>
              <a className={`${s.btn} ${s.btnGoogle}`} href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer">Write a Google review</a>
            </div>
          </div>
        ) : null}

        {/* Customer app next — the client side is the focus. */}
        <div className={s.card}>
          <h2>Review the BestHand app</h2>
          <p>For customers who book services.</p>
          <div className={s.btns}>
            <a className={s.btn} href={CLIENT_IOS} target="_blank" rel="noopener noreferrer">App Store</a>
            <a className={s.btn} href={CLIENT_ANDROID} target="_blank" rel="noopener noreferrer">Google Play</a>
          </div>
        </div>

        {/* Pro/worker app last — de-emphasized. */}
        <div className={s.card}>
          <h2>Review BestHand Pro</h2>
          <p>For workers who take jobs.</p>
          <div className={s.btns}>
            <a className={s.btn} href={PRO_IOS} target="_blank" rel="noopener noreferrer">App Store</a>
            <a className={s.btn} href={PRO_ANDROID} target="_blank" rel="noopener noreferrer">Google Play</a>
          </div>
        </div>
      </div>

      <p className={s.foot}>Had an issue with a job? Please contact <a href="mailto:support@besthandapp.com">support@besthandapp.com</a> first — we’ll make it right.</p>
    </div>
  </div>
);

export default withStyles(s)(ReviewPage);
